var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.761,
    height: 22.338,
    viewBox: "0 0 21.761 22.338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.887,
    y1: 0.705,
    x2: 0.24,
    y2: 0.418,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40eefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b402f6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_22",
    "data-name": "Union 22",
    d: "M6.822,21.538a10.816,10.816,0,0,1-3.451-2.283L1.545,21.13a.863.863,0,0,1-.638.277.861.861,0,0,1-.638-.277A.9.9,0,0,1,0,20.476V13.96a.909.909,0,0,1,.268-.654.861.861,0,0,1,.638-.277H7.254a.859.859,0,0,1,.637.277.929.929,0,0,1,0,1.309L5.95,16.607a7.291,7.291,0,0,0,2.281,1.484,6.908,6.908,0,0,0,2.649.523,6.98,6.98,0,0,0,3.541-.946,7.231,7.231,0,0,0,2.636-2.6,17.842,17.842,0,0,0,.75-1.7.426.426,0,0,1,.425-.334h2.721a.432.432,0,0,1,.319.137.458.458,0,0,1,.134.328.254.254,0,0,1-.013.1,11.351,11.351,0,0,1-3.8,6.318,10.222,10.222,0,0,1-6.773,2.421A10.372,10.372,0,0,1,6.822,21.538ZM14.507,9.307a.864.864,0,0,1-.637-.275.93.93,0,0,1,0-1.31l1.955-2.006a6.937,6.937,0,0,0-4.943-1.993,6.98,6.98,0,0,0-3.542.946A7.216,7.216,0,0,0,4.7,7.272a17.669,17.669,0,0,0-.751,1.7.426.426,0,0,1-.425.334H.707a.434.434,0,0,1-.319-.138.454.454,0,0,1-.133-.327v-.1A11.379,11.379,0,0,1,4.08,2.421,10.293,10.293,0,0,1,10.881,0,10.439,10.439,0,0,1,14.9.808a10.909,10.909,0,0,1,3.471,2.276l1.842-1.877a.876.876,0,0,1,1.275,0,.909.909,0,0,1,.269.654V8.376a.91.91,0,0,1-.269.656.864.864,0,0,1-.638.275Z",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.ad5051ec14f03120a48b477d1417643c.svg";
export { ForwardRef as ReactComponent };